import React from "react";

import { Box } from "@chakra-ui/react";

import { BusinessPayrollsTable } from "./BusinessPayrollsTable";

export const BusinessPayrolls = () => {
  return (
    <Box className="mt-1">
      <BusinessPayrollsTable />
    </Box>
  );
};
